import { tv } from 'tailwind-variants'

export const contactCardVariants = tv({
  slots: {
    container: 'flex flex-col',
    bubble: 'flex flex-col bg-white rounded-t-mili rounded-br-mili p-mili',
    icon: 'flex text-kilo text-primary-medium cursor-pointer mt-mili',
    textContainer: 'ml-micro',
    text: 'text-secondary-medium'
  },
  variants: {
    isReply: {
      true: {
        icon: 'text-secondary-xdark'
      }
    }
  }
})
